/**
 * Normal users see only these kinds on the catalog index (kind picker + table) and
 * in restricted URL filters. Direct ADMIN_GROUP members see all kinds.
 */
export const CATALOG_KINDS_FOR_ALL_USERS = ['component', 'template', 'api'] as const;

export type CatalogKindForAllUsers =
  (typeof CATALOG_KINDS_FOR_ALL_USERS)[number];

/**
 * Extra kinds non-admins may open via deep links, search, or sidebar (e.g. My Groups → Group,
 * profile → User). Catalog index still uses CATALOG_KINDS_FOR_ALL_USERS only.
 */
export const CATALOG_KINDS_ENTITY_PAGE_EXTRA_FOR_USERS = ['group', 'user'] as const;

export function isCatalogKindPublicToUsers(kind: string): boolean {
  const k = kind.toLowerCase();
  return (CATALOG_KINDS_FOR_ALL_USERS as readonly string[]).includes(k);
}

/** True if a non-admin may load /catalog/:ns/:kind/:name for this kind. */
export function isCatalogEntityPageAllowedForNonAdmin(kind: string): boolean {
  const k = kind.toLowerCase();
  if ((CATALOG_KINDS_FOR_ALL_USERS as readonly string[]).includes(k)) return true;
  return (CATALOG_KINDS_ENTITY_PAGE_EXTRA_FOR_USERS as readonly string[]).includes(k);
}
